import React from "react";
import LoadingPlaceholderBlock from "../../../../../components/common/LoadingPlaceholderBlock";
import styles from "../Utilities/Styles.module.css"

export default function PreSaleLoader() {
    return (
        <div className="sale-options">
            <div className={styles.flexMarginRight}>
                <LoadingPlaceholderBlock width={'75px'} height={'25px'} borderRadius={'16px'} backgroundColor={'rgb(239, 234, 229)'} />
                <span className={styles.mr5} />
                <LoadingPlaceholderBlock width={'75px'} height={'25px'} borderRadius={'16px'} backgroundColor={'rgb(239, 234, 229)'} />
            </div>
        </div>
    )
}